module.exports = __webpack_public_path__ + "static/media/card.66c3bdf1.png";